import { fonts } from '~/src/helpers/font';
import { EElementType, ILandingElement } from '~/src/services/projects';

export const TextBlock: ILandingElement = {
    title: 'TextBlock',
    type: EElementType.Block,
    label: 'Текстовый блок',
    properties: {
        blockName: '',
        customStyles: '',
        sortOrder: '',
        background: '',
        backgroundWebp: '',
        marginTop: '',
        marginBottom: '',
    },
    children: [
        {
            title: 'Text',
            type: EElementType.RTE,
            label: 'Описание',
            properties: {
                customize: {
                    font: fonts.S,
                    color: '#1A1A1A',
                    textAlign: 'left',
                    tag: '',
                },
                htmlContent: '<p>Текст...</p>',
                customStyles: '',
            },
        },
    ],
};
